import { ProfileItem } from "PFApp/components/profile_item";
import { Button } from "PFComponents/button";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./profiles_list.modules.scss";

const ProfilesList = ({ profiles, onRemove }) => {
  const { t } = useTranslation();

  return (
    <div className={css.profilesList}>
      {profiles.map((profile) => (
        <div key={profile.id} className={css.profileItem}>
          <ProfileItem profile={profile} style={{ flexWrap: "wrap" }} />
          <Button kind="danger" onClick={() => onRemove(profile.id)}>
            {t("remove")}
          </Button>
        </div>
      ))}
    </div>
  );
};

ProfilesList.propTypes = {
  profiles: PropTypes.array,
  onRemove: PropTypes.func
};

export default ProfilesList;
